export default "__VITE_ASSET__Cw$x52T5__"